import { DateRange } from 'owa-datetime-utils';
import { EventsCacheLockId } from 'owa-events-cache';
import { getStore } from '../store/store';
import { aggDateRanges } from 'owa-events-cache';

export function getEventsCacheLockInfo(lockId: EventsCacheLockId, folderId: string) {
    const store = getStore();
    const cache = store.calendarFolderEvents.get(folderId);
    return cache ? cache.locksInfo.get(lockId) : null;
}

export function getAllLockedDateRanges(folderId: string): DateRange[] {
    const cache = getEventsCache(folderId);
    return cache ? [...cache.locksInfo.entries()].reduce(aggDateRanges(), []) : [];
}

export function getAllFolderIdsLoadedInEventsCache(): string[] {
    const store = getStore();

    return [...store.calendarFolderEvents.keys()];
}

export function getEventsCache(folderId: string) {
    const store = getStore();
    const cache = store.calendarFolderEvents.get(folderId);
    return cache || null;
}

export function getAllCalendarEvents(folderId: string) {
    const cache = getEventsCache(folderId);

    // We return the copy of array so that it cant be manipulated from outside
    return cache ? [...cache.events] : [];
}

export function isEventsCacheInitialized(folderId: string) {
    return !!getEventsCache(folderId);
}
